import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';

/**
 * Récupère l'état d'une provision : funded_cents, drawn_cents, balance_cents, consumption_rate, health.
 * health : 'ok' | 'under_provisioned' | 'dormant_excess' | 'empty'
 */
export function useProvisionState(provisionId) {
  return useQuery({
    queryKey: ['provisions', provisionId, 'state'],
    queryFn: () => api.get(`/provisions/${provisionId}/state`),
    staleTime: 30_000,
    enabled: Boolean(provisionId),
  });
}
